export default "__VITE_ASSET__bdc346cb__"